<template>
    <div class="role-management">
        <create-dialog ref="createDialog" @created="fetchData" @updated="fetchData"></create-dialog>
        <user-role v-model="roleUserDialog" :item="currentItem" @closeDialog="roleUserDialog=false" ></user-role>
        
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Hệ thống Phân quyền
                <v-spacer></v-spacer> 
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="refreshAll" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>
                
                <v-divider vertical class="mx-4"></v-divider>

                <v-btn @click="openDialog" dark color="teal darken-4" class="rounded-pill elevation-3 ml-2 font-weight-bold px-6"> <v-icon left>mdi-plus</v-icon> TẠO PHÂN QUYỀN </v-btn>
            </v-card-title>
            
            <v-tabs v-model="tab" background-color="transparent" color="teal darken-4" class="px-6 border-b">
                <v-tab class="font-weight-bold text-none"><v-icon left small class="mr-2">mdi-shield-lock-outline</v-icon> Danh sách phân quyền</v-tab>
                <v-tab class="font-weight-bold text-none"><v-icon left small class="mr-2">mdi-account-multiple-outline</v-icon> User được phân quyền</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <!-- TAB 1: DANH SÁCH ROLE -->
                <v-tab-item>
                    <v-sheet class="grey lighten-4 py-4">
                        <div class="d-flex flex-wrap mx-n2 px-4">
                            <v-text-field label="Tìm kiếm nhóm quyền" placeholder="Nhập mã phân quyền, tên phân quyền..." dense v-model="search" outlined hide-details persistent-placeholder
                                class="mx-2 flex-grow-1 flex-shrink-1" style="background-color: white;"></v-text-field>
                        </div>
                    </v-sheet>
                    
                    <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                        <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                        <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                            <v-icon left small>mdi-file-document-outline</v-icon>
                            Tổng phân quyền: <b class="ml-1">{{ roles.length }}</b>
                        </v-chip>
                    </v-sheet>
                    
                    <v-data-table
                        height="calc(100vh - 350px)"
                        fixed-header
                        :mobile-breakpoint="0"
                        :headers="headers"
                        :items="roles"
                        :search="search"
                        :loading="loading"
                        loading-text="Đang tải dữ liệu..."
                        class="elevation-0 px-2 pb-2"
                        :items-per-page="15"
                    >
                        <template v-slot:[`item.code`]="{ item }">
                            <v-chip
                                label
                                small
                                color="blue-grey lighten-4"
                                text-color="blue-grey darken-3"
                                class="font-weight-medium px-2 shadow-sm"
                            >
                                {{ item.code }}
                            </v-chip>
                        </template>
                        
                        <template v-slot:[`item.roleName`]="{ item }">
                            <span class="font-weight-bold">{{ item.roleName }}</span>
                        </template>
                        
                        <template v-slot:[`item.description`]="{ item }">
                            <span v-if="item.description" class="text-body-2 black--text text--darken-2">
                                {{ item.description }}
                            </span>
                            <span v-else class="text-body-2 grey--text font-italic">
                                Không có mô tả
                            </span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            small
                                            color="blue darken-1"
                                            class="mr-1"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="editItem(item)"
                                        >
                                            <v-icon small>mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Chỉnh sửa</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            small
                                            color="success"
                                            class="mr-1"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="userDialog(item)"
                                        >
                                            <v-icon small>mdi-account-cog</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Gán người phẩn quyền</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            small
                                            color="error"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="deleteItem(item)"
                                        >
                                            <v-icon small>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Xóa</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>

                <!-- TAB 2: USER ĐƯỢC PHÂN QUYỀN -->
                <v-tab-item>
                    <v-sheet class="grey lighten-4 py-4">
                        <div class="d-flex flex-wrap mx-n2 px-4">
                            <v-text-field label="Tìm kiếm nhân sự" placeholder="Nhập mã NS, tên NS..." dense v-model="searchUser" outlined hide-details persistent-placeholder
                                class="mx-2 flex-grow-1 flex-shrink-1" style="background-color: white;"></v-text-field>
                        </div>
                    </v-sheet>

                    <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                        <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                        <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                            <v-icon left small>mdi-account-group-outline</v-icon>
                            Tài khoản User: <b class="ml-1">{{ users.length }}</b>
                        </v-chip>
                    </v-sheet>

                    <v-data-table
                        height="calc(100vh - 350px)"
                        fixed-header
                        :mobile-breakpoint="0"
                        :headers="userHeaders"
                        :items="users"
                        :search="searchUser"
                        :loading="loadingUsers"
                        loading-text="Đang tải dữ liệu User..."
                        class="elevation-0 px-2 pb-2"
                        :items-per-page="50"
                    >
                        <template v-slot:[`item.employeeCode`]="{ item }">
                            <span class="font-weight-bold blue-grey--text text--darken-3">{{ item.employeeCode }}</span>
                        </template>
                        <template v-slot:[`item.employeeName`]="{ item }">
                            <span class="font-weight-bold">{{ item.employeeName || item.userName }}</span>
                        </template>
                        <template v-slot:[`item.userRoles`]="{ item }">
                            <div class="d-flex flex-wrap py-1">
                                <v-chip 
                                    v-for="(role, index) in item.userRoles" 
                                    :key="index" 
                                    small 
                                    clickable
                                    color="teal lighten-5" 
                                    text-color="teal darken-4" 
                                    class="mr-1 my-1 font-weight-medium shadow-sm transition-swing"
                                    @click="openUserRole(role)"
                                >
                                    {{ role.roleName }}
                                </v-chip>
                                <span v-if="!item.userRoles || item.userRoles.length === 0" class="text-caption grey--text font-italic">Chưa có quyền</span>
                            </div>
                        </template>
                        <template v-slot:[`item.history`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small color="blue darken-2" v-bind="attrs" v-on="on" @click="openHistory(item)">
                                        <v-icon small>mdi-history</v-icon>
                                    </v-btn>
                                </template>
                                <span>Xem lịch sử thay đổi</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <v-dialog v-model="dialogDelete" max-width="450px" persistent>
            <v-card class="rounded-lg">
                <v-card-title class="headline text-h6 font-weight-bold pt-6 pb-4">
                    Xác nhận xóa
                </v-card-title>
                <v-card-text class="text-body-1">
                    Bạn có chắc chắn muốn xóa phân quyền <strong>{{ targetItem?.roleName }}</strong>?
                    Thao tác này không thể hoàn tác.
                </v-card-text>
                <v-card-actions class="px-6 pb-6 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="grey darken-1" 
                        text 
                        class="text-none px-4 rounded-md"
                        @click="dialogDelete=false"
                    >
                        Hủy bỏ
                    </v-btn>
                    <v-btn 
                        color="error" 
                        elevation="0" 
                        class="text-none px-4 rounded-md"
                        @click="cfmDeleteItem"
                    >
                        <v-icon left small>mdi-delete</v-icon>
                        Đồng ý xóa
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog hiển thị lịch sử thay đổi phân quyền của User -->
        <v-dialog v-model="dialogHistory" max-width="800px" scrollable>
            <v-card class="rounded-lg">
                <v-card-title class="px-6 py-4 border-b">
                    <span class="text-h6 font-weight-bold">Lịch sử phân quyền</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogHistory = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="px-6 py-4" style="max-height: 70vh;">
                    <div class="mb-4" v-if="currentUserForHistory">
                        <v-chip color="blue lighten-5" text-color="blue darken-4" class="font-weight-medium px-4">
                            <v-icon left small>mdi-account</v-icon>
                            Tài khoản: {{ currentUserForHistory.employeeName || currentUserForHistory.userName }} 
                            ({{ currentUserForHistory.employeeCode || currentUserForHistory.code }})
                        </v-chip>
                    </div>
                    <v-data-table
                        :headers="historyHeaders"
                        :items="histories"
                        :loading="loadingHistory"
                        loading-text="Đang tải dữ liệu lịch sử..."
                        class="elevation-1 rounded"
                        hide-default-footer
                        :items-per-page="-1"
                        no-data-text="Không có lịch sử thao tác."
                    >
                        <template v-slot:[`item.action`]="{ item }">
                            <v-chip small :color="item.action && (item.action.toLowerCase().includes('delete') || item.action.toLowerCase().includes('remove')) ? 'error' : 'success'" text-color="white" class="font-weight-bold shadow-sm">
                                {{ item.action || item.actionType }}
                            </v-chip>
                        </template>
                        <template v-slot:[`item.createdAt`]="{ item }">
                            {{ formatDate(item.createdAt) }}
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common'
import RoleCreateDialog from './Create'
import RoleUser from './User'

export default {
    name: "Role-index",
    components: {
        "create-dialog": RoleCreateDialog,
        "user-role": RoleUser,
    },
    data() {
        return {
            tab: 0,
            loading: false,
            loadingUsers: false,
            usersLoaded: false,
            currentItem: null,
            targetItem: null,
            roleUserDialog: false,
            roles: [],
            users: [],
            search: "",
            searchUser: "",
            dialogDelete: false,
            dialogHistory: false,
            loadingHistory: false,
            currentUserForHistory: null,
            histories: [],
            headers: [
                { text: 'Mã quyền', value: 'code', align: 'start', width: '150px' },
                {
                    text: 'Tên quyền',
                    align: 'start',
                    sortable: true,
                    value: 'roleName',
                    width: '30%'
                },
                { text: 'Mô tả chi tiết', value: 'description' },
                { text: 'Thao tác', value: 'actions', sortable: false, align: 'center', width: '180px' },
            ],
            userHeaders: [
                { text: 'Mã NS', value: 'employeeCode', align: 'start', width: '150px' },
                { text: 'Tên NS', value: 'employeeName', align: 'start', width: '25%' },
                { text: 'Phân quyền được phân công', value: 'userRoles', sortable: false },
                { text: 'Lịch sử thao tác', value: 'history', sortable: false, align: 'center', width: '130px' }
            ],
            historyHeaders: [
                { text: 'Resource', value: 'resource', width: '130px' },
                { text: 'Hành động', value: 'action', width: '120px', align: 'center' },
                { text: 'Mã đối tượng', value: 'targetCode', width: '150px' },
                { text: 'Ngày tạo', value: 'createdAt', width: '160px' },
                { text: 'Người tạo', value: 'createdBy', width: '120px' },
                { text: 'Tên người tạo', value: 'createdByName' },
                { text: 'Ghi chú', value: 'note' },
            ]
        }
    },
    watch: {
        tab(val) {
            if (val === 1 && !this.usersLoaded) {
                this.fetchUsers();
            }
        }
    },
    methods: {
        formatDate(value) {
            if(!value) return '';
            let date = new Date(value);
            return date.toLocaleDateString("vi-VN") + " " + date.toLocaleTimeString("vi-VN");
        },
        openHistory(item) {
            this.currentUserForHistory = item;
            this.dialogHistory = true;
            this.loadingHistory = true;
            this.histories = [];
            
            const userId = item.code || item.id || item.employeeCode;
            http.get("users/history/" + userId).then(res => {
                this.histories = res.data.data || [];
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.loadingHistory = false;
            });
        },
        openUserRole(userRole) {
            let matched = this.roles.find(r => r.roleName === userRole.roleName || r.code === userRole.roleCode || r.code === userRole.code);
            if (matched) {
                this.editItem(matched);
            } else {
                console.log("No matched role found for ", userRole);
                this.editItem(Object.assign({}, userRole, { code: userRole.roleCode || userRole.code || userRole.id }));
            }
        },
        refreshAll() {
            if (this.tab === 0) {
                this.fetchData();
            } else {
                this.fetchUsers();
            }
        },
        userDialog(item) {
            this.roleUserDialog = true;
            this.currentItem = item;
        },
        openDialog() {
            this.$refs.createDialog.dialog = true;
        },
        fetchData() {
            this.loading = true;
            return http.get("roles", {
                params: { dropDown: 1 }
            }).then(res => {
                this.roles = res.data;
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchUsers() {
            this.loadingUsers = true;
            // Similar to HR/User/Index.vue, we fetch users with a large pageSize to get all
            return http.get("users", {
                params: {
                    page: 1,
                    pageSize: 10000
                }
            }).then(res => {
                // Combine array objects users from API response
                if (res.data && res.data.users) {
                    this.users = res.data.users;
                }
                this.usersLoaded = true;
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.loadingUsers = false;
            });
        },
        cfmDeleteItem() {
            if (!this.targetItem) return;
            
            http.delete("roles/" + this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
                this.targetItem = null;
            }).catch(err => {
                console.log(err);
            });
        },
        editItem(item) {
            this.$refs.createDialog.isUpdate = true;
            this.$refs.createDialog.item = Object.assign({}, item);
            this.$refs.createDialog.fetchUpdate(item.code);
            this.$refs.createDialog.dialog = true;
        },
        deleteItem(item) {
            this.targetItem = item;
            this.dialogDelete = true;
        },
    },
    created() {
        this.fetchData();
    }
}
</script>

<style scoped>
.border-b {
    border-bottom: 1px solid #e0e0e0 !important;
}
.shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-weight: 600;
    font-size: 14px;
    background-color: #f8f9fa;
    white-space: nowrap;
}
</style>